module.exports = __webpack_public_path__ + "static/media/intro_cargador.99ae361c.gif";